define('plugin/invoice/view/InvoiceStatusView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Message view
     *
     * @class MessageView
     */
    return LayoutView.extend({

        template: '#invoice_status_view',

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.apply(this), this.model.getLineTypes());
        }

    });

});
